import Splide from '@splidejs/splide';
import {BREAKPOINTS} from "@utils/breakpoints";

export function resizeGallery() {
  const pdaGallery = (<HTMLElement>document.querySelector('.pda-gallery')),
      pdaLeft = (<HTMLElement>document.querySelector('.pda-left')),
      pdaTop = (<HTMLElement>document.querySelector('.pda-top')),
      header = (<HTMLElement>document.querySelector('header.head'));

  const scrollY = window.scrollY,
      galleryHeight = pdaGallery.offsetHeight,
      pdaLeftHeight = pdaLeft.offsetHeight,
      maxTopOffset = pdaLeftHeight - galleryHeight;

  const topOffset = pdaTop.getBoundingClientRect().top + window.scrollY + pdaTop.offsetHeight - (header.offsetHeight + 40);

  const isMobileView = window.innerWidth < BREAKPOINTS.tabletLandscape; /* it hurts to do that :( */

  if (pdaLeftHeight > galleryHeight && !isMobileView) {

    if (window.scrollY < pdaLeftHeight - galleryHeight + topOffset && window.scrollY >= topOffset && (scrollY - topOffset <= maxTopOffset)) {
      pdaGallery.style.transform = 'translateY('+ ( scrollY - topOffset ) +'px)';
    } else if (window.scrollY  < topOffset) {
      pdaGallery.style.transform = 'none';
    } else {
      pdaGallery.style.transform = `translateY(${maxTopOffset}px)`;
    }
  } else {
    pdaGallery.style.transform = 'none';
  }
}

export class Gallery {

  #splideGallery: null | Splide = null;

  pdaGallery() {
    if(document.querySelector('#pda-gallery-thumbnails') && document.querySelector('#pda-gallery-hero') && document.querySelector('#gallery-storage')) {
      const thumbSlides = [].slice.call(document.querySelectorAll('#pda-gallery-thumbnails li'));

      thumbSlides.forEach(function (slide:HTMLElement, index:number) {
        if(thumbSlides.length <= 1) {
          (<HTMLElement>document.querySelector('#pda-gallery-thumbnails')).style.display = 'none';
          (<HTMLElement>document.querySelector('#pda-gallery-hero')).classList.add('no-border');
        }
        slide.dataset.index = index.toString();
      })

      this.#splideGallery.on('active', () => {
        const hasVideo = document.querySelectorAll('.splide__slide.product-video video');
        hasVideo.forEach((video: HTMLVideoElement) => video.pause());
      });

      thumbSlides.forEach(function (thumb:HTMLElement, index:any) {
        if(index == 0) {
          thumb.classList.add('active');
        }

        thumb.addEventListener('click',  () => {
          if(document.querySelector('.pda.pda-lightbox')) {
            if(thumb.getAttribute('data-type') == '360' || thumb.getAttribute('data-type') == 'video') return;
          }

          thumbSlides.forEach(function (thumb:HTMLElement) {
            thumb.classList.remove('active');
          })
          thumb.classList.add('active');
        })
      })
    }
  }

  handlePdaGalleryScroll() {
    const pdaGallery = (<HTMLElement>document.querySelector('.pda-gallery'))

    let windowWidth: number = window.innerWidth;
    let scrollingActive: boolean = windowWidth >= BREAKPOINTS.tabletLandscape;

    window.addEventListener('resize', function () {
      windowWidth = window.innerWidth;
      scrollingActive = windowWidth >= BREAKPOINTS.tabletLandscape;

      if (!scrollingActive) {
        pdaGallery.style.transform = 'translateY(0px)';
      }
    })

    function scrollGallery() {
      if (scrollingActive) {
        resizeGallery()
      }
    }
    scrollGallery();

    window.addEventListener('scroll', scrollGallery);
  }

  lightbox() {
    const pdaGalleryElement = document.getElementById('pda-gallery-hero');

    const pdaGallery360Thumbs = Array.from(document.querySelectorAll('#pda-gallery-thumbnails li[data-type="360"]'));
    const pdaGalleryVideoThumbs = Array.from(document.querySelectorAll('#pda-gallery-thumbnails li[data-type="video"]'));

    const pdaGalleryMobile360Button = document.querySelector('#mobile-360-button');

    if(pdaGallery360Thumbs.length > 0) {
      pdaGalleryMobile360Button.parentElement.classList.add('active');
    }

    const lightbox = document.getElementById('pda-lightbox-outer'),
        lightboxLeft:HTMLElement = lightbox.querySelector('.pda-lightbox-left'),
        lightboxClose = lightbox.querySelector('.lightbox-close'),
        lightboxMobileClose = lightbox.querySelector('.lightbox-mobile-close');

    const mainStageElements = Array.from(lightbox.querySelectorAll('.main-view li')),
        thumbnailImages = Array.from(lightbox.querySelectorAll('.thumb-views li'));

    const lightboxTabs = Array.from(lightbox.querySelectorAll('.lightbox-tabs-header > div')),
        lightboxTabContent = Array.from(lightbox.querySelectorAll('.lightbox-tabs-content > div'));

    let initialImage:HTMLElement;
    let lightboxInitialized = false;

    let thumbnailsInTab:Array<HTMLElement>;

    let activeZoomContainer:HTMLElement;

    const lightboxSlider = new Splide( '#pda-lightbox-outer .main-view', {
      type       : 'slide',
      pagination : false,
      drag       : window.innerWidth < BREAKPOINTS.tabletLandscape,
      arrows     : window.innerWidth >= BREAKPOINTS.tabletLandscape,
      arrowPath: 'M14.7,31.6c-0.2,0-0.5,0-0.7-0.2c-0.4-0.4-0.4-0.9,0-1.3l10-10L13.8,9.9c-0.4-0.4-0.4-0.9,0-1.3c0.4-0.4,0.9-0.4,1.3,0l11.6,11.6L15.4,31.5C15.2,31.6,14.9,31.6,14.7,31.6z'
    } ).mount();

    (<any>window).lsl1 = lightboxSlider;

    // Lightbox open & close
    pdaGalleryElement.addEventListener('click', openLightbox);
    lightboxClose.addEventListener('click', closeLightbox);
    lightboxMobileClose.addEventListener('click', closeLightbox);
    pdaGalleryMobile360Button.addEventListener('click', openLightbox);

    document.addEventListener('keydown', function (e) {
      if (e.key == 'Escape') closeLightbox();
    });

    pdaGallery360Thumbs.forEach(thumb => {
      thumb.addEventListener('click', openLightbox);
    })
    pdaGalleryVideoThumbs.forEach(thumb => {
      thumb.addEventListener('click', openLightbox);
    })
    document.addEventListener('click', (e) => {
      if((e.target as HTMLElement).id == 'pda-lightbox-outer') {
        closeLightbox();
      }
    });

    // Tab logic
    function initiateTabs() {
      // Set listener to switch tabs
      lightbox.querySelector('.lightbox-tabs-header').addEventListener('click', function (e) {
        const targetTab = e.target as HTMLElement;
        if (targetTab.classList.contains('lightbox-tab')) setActiveTab(targetTab, true);
      })
    }
    function hideEmptyTabs() {
      const articleId = document.getElementById('article-id').getAttribute('data-article-id');

      for (var i=0; i<lightboxTabs.length; i++) {
        if (lightboxTabContent[i].querySelector('.thumb-views li[data-article-id="' + articleId + '"], .thumb-views li[data-gallery="alwaysshown"]')) {
          (<HTMLElement>lightboxTabs[i]).style.display = 'block';
        } else {
          (<HTMLElement>lightboxTabs[i]).style.display = 'none';
        }
      }
    }
    function setActiveTab(targetTab:HTMLElement, displayFirstElementInTab?:Boolean) {
      for (var i=0; i<lightboxTabs.length; i++) {
        if (targetTab == lightboxTabs[i]) {

          const targetTabContent = lightboxTabContent[i];

          // Current slides back to storage
          const currentSlides = [].slice.call(document.querySelectorAll('#pda-lightbox-outer .main-view li'));
          currentSlides.forEach(function (slide:HTMLElement) {
            document.querySelector('#pda-lightbox-outer .main-view-storage').appendChild(slide);
          })

          // New selection of slides back to slider
          thumbnailsInTab = Array.from(targetTabContent.querySelectorAll('.thumb-views li'));
          const articleId = document.getElementById('article-id').getAttribute('data-article-id');
          let thumbnailsToBeShown:Array<HTMLElement> = [];

          thumbnailsInTab.forEach(thumbnail => {
            if(thumbnail.getAttribute('data-article-id') == articleId || thumbnail.getAttribute('data-gallery') == 'alwaysshown') {
              thumbnailsToBeShown.push(thumbnail);
              thumbnail.style.display = 'list-item';
              const identifier = thumbnail.getAttribute('data-thumbnail-index');
              lightboxSlider.add((<HTMLElement>document.querySelector('#pda-lightbox-outer .main-view-storage [data-image-index="'+identifier+'"]')));
            } else {
              thumbnail.style.display = 'none';
            }
            thumbnail.classList.remove('active');
          });
          lightboxSlider.refresh();

          if (displayFirstElementInTab) {
            lightboxSlider.options = {
              drag: window.innerWidth < BREAKPOINTS.tabletLandscape
            };
            updateMainStage(thumbnailsToBeShown[0].getAttribute('data-thumbnail-index'));
          }

          targetTab.classList.add('active')
          targetTabContent.classList.add('active')
        } else {
          lightboxTabs[i].classList.remove('active')
          lightboxTabContent[i].classList.remove('active')
        }
      }
    }

    lightboxSlider.on( 'move', function (e) {
      thumbnailsInTab.forEach((thumbnail, index) => {
        if (index == e) {
          thumbnail.classList.add('active');
        } else {
          thumbnail.classList.remove('active');
        }
      })

      if (activeZoomContainer) {
        activeZoomContainer.style.backgroundSize = '0';
        lightboxSlider.root.classList.remove('zoom-active');
        activeZoomContainer.classList.remove('active');
      }
    });
    lightboxSlider.on( 'active', function (e) {
      const hasVideo = lightbox.querySelectorAll('.main-view .splide__slide.product-video video');
      hasVideo.forEach((video: HTMLVideoElement) => video.pause());

      if (e.slide.getAttribute('data-type') == 'normal') {
        const viewportAspectRatio = lightboxLeft.getBoundingClientRect().width / lightboxLeft.getBoundingClientRect().height,
            imageElement = (<HTMLImageElement>e.slide.querySelector('img')),
            naturalImageWidth = imageElement.naturalWidth,
            naturalImageHeight = imageElement.naturalHeight,
            displayedImageWidth = imageElement.getBoundingClientRect().width,
            imageAspectRatio = naturalImageWidth / naturalImageHeight;

        //let zoomlevel = naturalImageWidth / displayedImageWidth * 100;
        //zoomlevel < 200 ? zoomlevel = 200 : null ;

        if(viewportAspectRatio <= imageAspectRatio) {
          e.slide.classList.add('useMaxWidth');
        } else {
          e.slide.classList.remove('useMaxWidth');
        }

        imageZoom(e.slide.querySelector('.containerZoom'), {zoom: 200});
      } else if (e.slide.getAttribute('data-type') == '360') {
        /* TODO; INC-1258 removed for better 360 view. Keep this just for transparents */
      }
    });

    function updateMainStage(assetIdentifier: String) {
      const mainImage:HTMLElement = lightbox.querySelector('[data-image-index="'+assetIdentifier+'"]');
      const matchingThumbnail = lightbox.querySelector('[data-thumbnail-index="'+assetIdentifier+'"]');

      let indexToGoTo: number;

      thumbnailsInTab.forEach((thumbnail, index) => {
        if (thumbnail == matchingThumbnail) indexToGoTo = index;
      })

      lightboxSlider.go(indexToGoTo);
    }

    function openLightbox(e:Event) {
      //return if slider empty
      if (document.getElementById('pda-gallery-hero-list').innerHTML.trim() == '') {
        return;
      }

      let identifier:String;
      let tabType:String;



      if((e.target as HTMLElement).id == 'mobile-360-button') {
        tabType = '360';
      } else {
        initialImage = e.target as HTMLElement;
        const parentListElement = initialImage.closest("li");

        if ( !parentListElement && !parentListElement.classList.contains("splide__slide") ) return console.warn("li element not from splide");

        if (parentListElement.hasAttribute("role") && parentListElement.getAttribute("role") === 'presentation') return;
        identifier = parentListElement.getAttribute('data-image-index') ?? parentListElement.getAttribute('data-thumbnail-index');

        if (identifier) {
          tabType = lightbox.querySelector('[data-thumbnail-index="'+identifier+'"]').getAttribute('data-type');
        }
      }

      lightbox.querySelector('.lightbox-product-title').innerHTML = document.getElementById('article-title').innerHTML;
      lightbox.style.display = 'block';

      document.getElementsByTagName('html')[0].style.overflow = 'hidden';

      if(!lightboxInitialized) {
        initiateTabs();
        thumbnailImages.forEach(view => {
          view.addEventListener('click', function () {
            lightboxSlider.options = {
              drag: window.innerWidth < BREAKPOINTS.tabletLandscape
            };
            updateMainStage(this.getAttribute('data-thumbnail-index'));
          })
        })

        lightboxInitialized = true;
      }

      hideEmptyTabs();

      // Set active tab based on asset type
      setActiveTab(lightbox.querySelector('.lightbox-tabs-header [data-type="'+ tabType +'"]'), (e.target as HTMLElement).id == 'mobile-360-button');

      lightbox.classList.add('active');

      if ((e.target as HTMLElement).id != 'mobile-360-button') updateMainStage(identifier);
    }
    function closeLightbox() {
      lightbox.classList.remove('active');

      const hasVideo = lightbox.querySelectorAll('.main-view .splide__slide.product-video video');
      hasVideo.forEach((video: HTMLVideoElement) => video.pause());

      document.getElementsByTagName('html')[0].style.overflow = 'auto';

      const tabs = Array.from(lightbox.querySelectorAll('.tabs-header > div'));
      tabs.forEach(tab => {
        tab.classList.remove('active');
      });
    }

    // Function to pan the zoomed image according to mouse movement
    function zoomIn(e: any) {

      let zoomElement = e.currentTarget as HTMLElement;

      let x, y, offsetX, offsetY;
      if(e.offsetX) {
        offsetX = e.offsetX;
        x = offsetX / zoomElement.offsetWidth * 100;
      } else if(e.touches[0]) {
        offsetX = e.touches[0].pageX;
        x = 100 - (offsetX / zoomElement.offsetWidth * 100);
      }
      if(e.offsetY) {
        offsetY = e.offsetY;
        y = offsetY / zoomElement.offsetHeight * 100;
      } else if(e.touches[0]) {
        offsetY = e.touches[0].pageY;
        y = 100 - (offsetY / zoomElement.offsetHeight * 100);
      }

      zoomElement.style.backgroundPosition = `${x}% ${y}%`;
    }

    function imageZoom(element: HTMLElement, options: Object) {
      // Set zoom level to default value if not passed
      let settings = Object.assign({zoom: 200}, options);

      if(element.classList.contains('initialized')) return;
      element.classList.add('initialized');

      let zoomActive = false;

      // Wrap img tag with figure tag
      // var container = document.createElement('figure');
      // container.classList.add('containerZoom');
      // container.style.backgroundImage = `url('${element.getAttribute('src')}')`;
      // container.style.backgroundSize = settings.zoom + '%';
      // container.innerHTML = `<img id="imageZoom" src="${element.getAttribute('src')}" alt="${element.getAttribute('alt')}" />`;
      // element.parentNode.replaceChild(container, element);

      const container = element;
      container.style.backgroundSize = '0';

      // Attach mouse listeners to figure element
      container.addEventListener('click', function(e:PointerEvent) {
        console.log(e.pointerType);
        if (e.pointerType != 'touch') {
          if (zoomActive) {
            zoomActive = false;
            container.style.backgroundSize = '0';
            lightboxSlider.root.classList.remove('zoom-active');
            container.classList.remove('active');
          } else {
            zoomActive = true;
            activeZoomContainer = container;
            container.style.backgroundSize = settings.zoom + '%';
            lightboxSlider.root.classList.add('zoom-active');
            container.classList.add('active');
            zoomIn(e);
          }
          console.log(zoomActive, 'click');
        }
      })
      container.addEventListener('mousemove', function (e) {
        zoomActive ? zoomIn(e) : null;
      })
      container.addEventListener('mouseleave', function () {
        //zoomActive = false;
        //container.style.backgroundSize = '0';
        //lightboxSlider.root.classList.remove('zoom-active');
        //container.classList.remove('active');
      })

      //container.addEventListener("touchstart", function(e) {console.log(e)});
      //container.addEventListener("touchend", function(e) {console.log(e)});
      //container.addEventListener("touchcancel", function(e) {console.log(e)});
      //container.addEventListener("touchleave", function(e) {console.log(e)});
      container.addEventListener('touchmove', function(e) {zoomActive ? zoomIn(e) : null;});

      let timeout: any;
      let lastTap = 0;
      container.addEventListener('touchend', function(e) {
        var currentTime = new Date().getTime();
        var tapLength = currentTime - lastTap;
        clearTimeout(timeout);
        if (tapLength < 500 && tapLength > 0) {
          zoomActive = !zoomActive;
          console.log(zoomActive, 'tap');
          if (zoomActive) {
            lightboxSlider.options = {
              drag: false,
            };
            activeZoomContainer = container;
            container.style.backgroundSize = settings.zoom + '%';
            lightboxSlider.root.classList.add('zoom-active');
            container.classList.add('active');
            zoomIn(e);
          } else {
            lightboxSlider.options = {
              drag: window.innerWidth < BREAKPOINTS.tabletLandscape,
            };
            container.style.backgroundSize = '0';
            lightboxSlider.root.classList.remove('zoom-active');
            container.classList.remove('active');
          }
        } else {
          timeout = setTimeout(function() {
            clearTimeout(timeout);
          }, 500);
        }
        lastTap = currentTime;
      });
    }
  }

  init() {
    this.initializeSplideGallery();
    this.mountSliders();
    this.pdaGallery();
    this.handlePdaGalleryScroll();
    this.thumbnailClickHandler();

    if (document.querySelector('.pda.pda-lightbox')) {
      this.lightbox();
    }
  }

  private thumbnailClickHandler() {
    const thumbnails = Array.from(document.querySelector("#pda-gallery-thumbnails")?.querySelectorAll(".thumbnail"));

    if (thumbnails.length === 0) {
      /*TODO: remove console.log before deploy*/
      console.log("no Thumbnails exist");
      return;
    }

    for ( const thumbnail of thumbnails) {
      const dataIndex: number = Number(thumbnail?.getAttribute("data-index"));
      thumbnail.addEventListener("click", () => {
        /* change main slide */
        this.#splideGallery.go(dataIndex);
      })
    }
  }

  private initializeSplideGallery() {
    this.#splideGallery = new Splide( '#pda-gallery-hero', {
      pagination : false,
      drag       : window.innerWidth < BREAKPOINTS.tabletLandscape,
      arrows     : false,
      breakpoints: {
        991: {
          pagination: true,
        }
      }
    } );
  }

  private mountSliders() {
    this.#splideGallery.mount();
    /* needed for product change like color to update DOM */
    (<any>window).sl1 = this.#splideGallery;
  }
}